export const PO_BOX_REGEX =
  /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin))? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)) *(number|num|#)? *\d+|(num|number|#) *\d+)/i;
